<template>
    <BreadCrumb PageTitle="Liste des Décodeurs" />
    <ListeDecodeur />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeDecodeur from "../../components/Decodeur/ListeDecodeur.vue";

    export default defineComponent({
        name: "ListeDecodeurPage",
        components: {
            BreadCrumb,
            ListeDecodeur,
        },
    });
</script>